import React from 'react';
import { Typography, Space } from 'antd';
import { spacing } from './tokens';
import { Breadcrumbs } from '../components/layout/Breadcrumbs';

const { Title } = Typography;

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumbs?: Array<{ path: string; label: string }>;
  showBreadcrumbs?: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  breadcrumbs,
  showBreadcrumbs = false,
}) => {
  return (
    <div style={{ marginBottom: spacing.lg }}>
      {showBreadcrumbs && (
        <div style={{ marginBottom: spacing.md }}>
          <Breadcrumbs items={breadcrumbs} />
        </div>
      )}
      <Space
        style={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: subtitle ? 'flex-start' : 'center',
          flexWrap: 'wrap',
        }}
      >
        <div>
          <Title
            level={2}
            style={{ margin: 0, marginBottom: subtitle ? spacing.xs : 0 }}
          >
            {title}
          </Title>
          {subtitle && (
            <div
              style={{ color: '#666', fontSize: '14px', marginTop: spacing.xs }}
            >
              {subtitle}
            </div>
          )}
        </div>
        {actions && <div>{actions}</div>}
      </Space>
    </div>
  );
};
